/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DurationsByType
 */
export interface DurationsByType {
    /**
     * 
     * @type {number}
     * @memberof DurationsByType
     */
    compute?: number;
    /**
     * 
     * @type {number}
     * @memberof DurationsByType
     */
    diskWrite?: number;
    /**
     * 
     * @type {number}
     * @memberof DurationsByType
     */
    diskRead?: number;
    /**
     * 
     * @type {number}
     * @memberof DurationsByType
     */
    deserialize?: number;
    /**
     * 
     * @type {number}
     * @memberof DurationsByType
     */
    transfer?: number;
}

/**
 * Check if a given object implements the DurationsByType interface.
 */
export function instanceOfDurationsByType(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DurationsByTypeFromJSON(json: any): DurationsByType {
    return DurationsByTypeFromJSONTyped(json, false);
}

export function DurationsByTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DurationsByType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'compute': !exists(json, 'compute') ? undefined : json['compute'],
        'diskWrite': !exists(json, 'disk_write') ? undefined : json['disk_write'],
        'diskRead': !exists(json, 'disk_read') ? undefined : json['disk_read'],
        'deserialize': !exists(json, 'deserialize') ? undefined : json['deserialize'],
        'transfer': !exists(json, 'transfer') ? undefined : json['transfer'],
    };
}

export function DurationsByTypeToJSON(value?: DurationsByType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'compute': value.compute,
        'disk_write': value.diskWrite,
        'disk_read': value.diskRead,
        'deserialize': value.deserialize,
        'transfer': value.transfer,
    };
}

